import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import Femininos from "./pages/Femininos";
import Arabes from "./pages/Arabes";
import Masculinos from "./pages/Masculinos";
import Nicho from "./pages/Nicho";
import Home from "./pages/Home";
import Sugestoes from "./pages/Sugestoes";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/masculinos" element={<Masculinos />} />
        <Route path="/femininos" element={<Femininos />} />
        <Route path="/arabes" element={<Arabes />} />
        <Route path="/nicho" element={<Nicho />} />
        <Route path="/sugestoes" element={<Sugestoes />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
